import { isEmpty } from 'lodash'
import i18n from 'translations/i18n'
import { ListDataTypes } from 'types/sharedComponents'
import { Dropdown, Select } from '@jisr-hr/ds-beta'
import GroupItem from './GroupItem'
import { getSortedListByGroup } from '../multiGroupChecklist/helper'
import { GroupListPropsT } from './helper'
import styles from './group-select.module.scss'

const MultiGroupSelectList = (props: GroupListPropsT): JSX.Element => {
  const { list, groupKey, value, labelKey, valueKey, onChange } = props

  const groupedList = !isEmpty(list) && groupKey ? getSortedListByGroup(list, groupKey) : []

  const optionsList = Object.values(groupedList).flatMap((e) => e)

  return (
    <div className={styles.dropdownWrapper}>
      <Dropdown
        key={value}
        value={value}
        withPortal
        width="436px"
        dropDownElement={
          <Select
            value={optionsList.find((e) => e[valueKey ?? 'id'] === value)}
            valueKey={valueKey}
            labelKey={labelKey}
            options={optionsList}
            open={false}
          />
        }
      >
        <div className="max-h-[300px] overflow-auto">
          {!isEmpty(groupedList) &&
            Object.entries(groupedList).map((e, k) => {
              return (
                <GroupItem
                  key={k}
                  title={i18n.t(e[0] !== 'undefined' ? e[0] : '')}
                  list={e[1] as ListDataTypes[]}
                  onChange={(data) => {
                    if (data) {
                      onChange(data)
                    }
                  }}
                  value={value}
                  labelKey={labelKey}
                  valueKey={valueKey}
                />
              )
            })}
        </div>
      </Dropdown>
    </div>
  )
}

export default MultiGroupSelectList
